/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsVulnerabilityVendorComment {
    getFixupPrototypeFunction() { return AppSecopsVulnerabilityVendorComment.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsVulnerabilityVendorComment>): AppSecopsVulnerabilityVendorComment {
        let obj = Object.assign(new AppSecopsVulnerabilityVendorComment(), model);
        AppSecopsVulnerabilityVendorComment.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsVulnerabilityVendorComment>): AppSecopsVulnerabilityVendorComment {
        if (!model) return null;
        return AppSecopsVulnerabilityVendorComment.newInstance(<AppSecopsVulnerabilityVendorComment> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsVulnerabilityVendorComment) {
        if (!obj) return;

        models.AppSecopsVulnerabilityVendorComment.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsVulnerabilityVendorComment): boolean {
        Object.setPrototypeOf(obj, AppSecopsVulnerabilityVendorComment.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.lastModified === "string") {
            this.lastModified = new Date(<string><any>this.lastModified);
        }
    }

    /**
     * Name of the vendor or organization providing the comment
     */
    organization: string;

    /**
     * Vendor’s statement or advisory regarding the vulnerability
     */
    comment: string;

    /**
     * Date and time when the comment was last updated
     */
    lastModified: Date;

}
